<template>
  <v-container
    class="LKMunMehFormsListFilter"
  >
    <BListFilter
      v-model="form"
      label="Поиск"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />
  </v-container>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  status: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

export default {
  name: 'LKMunMehFormsListFilter',
  components: {
    BListFilter,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormsListFilter {
  padding: 0 !important;
  margin: 16px 0;
}
</style>
